import "controllers"
// The api-maker base model and the generated models form a circular dependency:
// the models index must start initializing the circle, or the generated models
// would extend a not-yet-defined base model.
import "models.js"
import {BrowserRouter, useRoutes} from "react-router-dom"
import React, {Suspense} from "react"
import abilitiesToLoad from "../admin/abilities-to-load"
import AnimatedTransition from "components/animated-transition"
import {App} from "../components/app"
import {CanCanApp} from "shared/can-can-app"
import {createRoot} from "react-dom/client"
import FlashMessages from "nemoa/components/flash-messages"
import LoadingSplash from "components/loading-splash"
import {readRoutes} from "shared/resource-routes"
import ScrollToTop from "shared/scroll-to-top"

// Lazy components must have stable identity across renders: with
// concurrent rendering (createRoot), a React.lazy created inside render
// (e.g. in a useMemo) is recreated on every suspend/retry cycle, which
// re-suspends forever because each new instance starts a fresh import.
const lazyRouteComponents = new Map()

const requireComponent = (component) => {
  if (!lazyRouteComponents.has(component)) {
    lazyRouteComponents.set(component, React.lazy(() => import(/* webpackChunkName: "[request]" */ `admin/routes/${component}`)))
  }

  return lazyRouteComponents.get(component)
}

function RouteDefinitions() {
  const routes = readRoutes({
    requireComponent,
    routeDefinitions: require("admin/route-definitions.json")
  })

  return useRoutes(routes)
}

require("stylesheets/application")
require("stylesheets/contained-image")
require("shared/devise")
require("shared/error-logger")
require("shared/i18n")
require("shared/session-status-updater")

document.addEventListener("DOMContentLoaded", () => {
  const reactRoot = document.querySelector(".react-root")

  createRoot(reactRoot).render(
    (
      <BrowserRouter>
        <Suspense fallback={<LoadingSplash />}>
          <App>
            <ScrollToTop />
            <FlashMessages />
            <AnimatedTransition>
              <CanCanApp abilities={abilitiesToLoad}>
                <RouteDefinitions />
              </CanCanApp>
            </AnimatedTransition>
          </App>
        </Suspense>
      </BrowserRouter>
    )
  )
})
